import React from "react";

export default function ReportMain(props) {
  var date = props.data[7].split("-");
  var wDays = [
    "ایک",
    "دو",
    "تین",
    "چار",
    "پانچ",
    "چھ",
    "سات",
    "آٹھ",
    "نو",
    "دس",
    "گیارہ",
    "بارہ",
    "تیرہ",
    "چودہ",
    "پندرہ",
    "سولہ",
    "سترہ",
    "اٹھارہ",
    "انیس",
    "بیس",
    "اکیس",
    "بائیس",
    "تئیس",
    "چوبیس",
    "پچیس",
    "چھببیس",
    "ستائیس",
    "اٹھائیس",
    "انتیس",
    "تیس",
    "اکتیس"
  ];
  var wMonths = [
    "جنوری",
    "فروری",
    "مارچ",
    "اپریل",
    "مئی",
    "جون",
    "جولائی",
    "اگست",
    "ستمبر",
    "اکتوبر",
    "نومبر",
    "دسمبر"
  ];
  var wNumbers = [
    "ایک",
    "دو",
    "تین",
    "چار",
    "پانچ",
    "چھ",
    "سات",
    "آٹھ",
    "نو",
    "دس",
    "گیارہ",
    "بارہ",
    "تیرہ",
    "چودہ",
    "پندرہ",
    "سولہ",
    "سترہ",
    "اٹھارہ",
    "انیس",
    "بیس",
    "بیس",
    "بائیس"
  ];

  var wwnumber = [
    "صفر",
    "ایک",
    "دو",
    "تین",
    "چار",
    "پانچ",
    "چھ",
    "سات",
    "آٹھ",
    "نو",
    "دس",
    "گیارہ",
    "بارہ",
    "تیرہ",
    "چودہ",
    "پندرہ",
    "سولہ",
    "سترہ",
    "اٹھارہ",
    "انیس",
    "بیس",
    "اکیس",
    "بائیس",
    "تئیس",
    "چوبیس",
    "پچیس",
    "چھببیس",
    "ستائیس",
    "اٹھائیس",
    "انتیس",
    "تیس",
    "اکتیس",
    "بتیس",
    "تینتیس",
    "چونتیس",
    "پینتیس",
    "چھتیس",
    "سینتیس",
    "اڑتیس",
    "انتالیس",
    "چالیس",
    "اکتالیس",
    "بیالیس",
    "تینتالیس",
    "چوالیس",
    "پینتالیس",
    "چھیالیس",
    "سینتالیس",
    "اڑتالیس",
    "انچاس",
    "پچاس",
    "اکیاون",
    "باون",
    "ترپن",
    "چون",
    "پچپن",
    "چھپن",
    "ستاون",
    "اٹھاون",
    "انسٹھ",
    "ساٹھ",
    "اکسٹھ",
    "باسٹھ",
    "ترسٹھ",
    "چوسٹھ",
    "پینسٹھ",
    "چھیاسٹھ",
    "سڑسٹھ",
    "اٹھسٹھ",
    "انہتر",
    "ستر",
    "اکہتر",
    "بہتر",
    "تہتر",
    "چوہتر",
    "پچہتر",
    "چھہتر",
    "ستتر",
    "اٹھہتر",
    "اناسی",
    "اسی",
    "اکیاسی",
    "بیاسی",
    "تراسی",
    "چوراسی",
    "پچاسی",
    "چھیاسی",
    "ستاسی",
    "اٹھاسی",
    "نواسی",
    "نوے",
    "اکانوے",
    "بانوے",
    "ترانوے",
    "چورانوے",
    "پچانوے",
    "چھیانوے",
    "ستانوے",
    "اٹھانوے",
    "ننانوے"
  ];
  var day = parseInt(date[0]) - 1;
  var month = parseInt(date[1]) - 1;
  var year = date[2];
  var x = year.charAt(0);
  var xx = year.charAt(1);
  var xxx = parseInt(year.charAt(2)) * 10 + parseInt(year.charAt(3)) + 1;

  var a = parseInt(x + xx) - 1;
  var b = parseInt(xxx) - 1;
  let word =
    wDays[day] +
    "  " +
    wMonths[month] +
    "  " +
    wNumbers[a] +
    " صد " +
    wwnumber[b];

  return (
    <div className="p-2">
      {" "}
      <div className="row">
        <div className="col">
          سکول کا نام: <span> {props.data[1]}</span>
        </div>
        <div className="col">
          ضلع :<span> {props.data[0]} </span>
        </div>
      </div>
      <div className="row ">
        <div className="col">
          نام طالب علم: <span> {props.data[5]}</span>
        </div>
        <div className="col">
          ولدیت :<span> {props.data[6]}</span>
        </div>
      </div>
      <div className="row ">
        <div className="col-4">
          ب فارم نمبر:{" "}
          <span style={{ direction: "ltr", display: "inline-block" }}>
            {" "}
            {props.data[9]}
          </span>
        </div>
        <div className="col-2">
          جماعت :<span> {props.data[2]} </span>
        </div>
        <div className="col-2">
          رو لنمبر: <span> {props.data[4]}</span>
        </div>
        <div className="col-4">
          سیکشن :<span>{props.data[3]} </span>
        </div>
      </div>
      <div className="row">
        <div className="col">
          تاریخ پیدائش &#40; ہندسوں میں &#41; :
          <span style={{ direction: "ltr", display: "inline-block" }}>
            {props.data[7]}
          </span>
        </div>
      </div>
      <div className="row "></div>
      <div className="row ">
        <div className="col">تاریخ پیدائش &#40; لفظوں میں &#41; :{word}</div>
      </div>
      <div className="row mb-1"></div>
    </div>
  );
}
